import request from './request'

export function sendSmsCode(data) {
    return request({
        url: '/api/sendSmsCode',
        method: 'get',
        params: data
    })
}